import { QueryClient } from '@tanstack/react-query'

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30 * 1000,
      gcTime: 10 * 60 * 1000,
      retry: 1,
      refetchOnWindowFocus: true,
      refetchOnMount: true,
    },
  },
})

// Dev-mode observability — see src/lib/auth.ts for matching window exposures
// of useAuth + supabase. Active in local dev AND on dev.orkestrapro.com; the
// hostname check excludes any future real-production hostname automatically.
const isDiagnosticContext =
  import.meta.env.DEV ||
  (typeof window !== 'undefined' &&
   window.location.hostname === 'dev.orkestrapro.com')
if (isDiagnosticContext) {
  if (typeof window !== 'undefined') {
    ;(window as any).queryClient = queryClient
  }
}
